import React from "react";
import styles from "./Terms.module.css";

export default function Terms() {
  return (
    <div className={styles.container}>
      <h1>Términos y Condiciones</h1>

      <section>
        <h2>1. Objeto y aceptación</h2>
        <p>
          Bienvenido a Medicina Total. Estos Términos y Condiciones regulan el uso
          de nuestra plataforma de cursos de medicina online. Al registrarte o utilizar
          el sitio, aceptás cumplir con estos términos.
        </p>
      </section>

      <section>
        <h2>2. Definiciones</h2>
        <ul>
          <li><strong>Plataforma:</strong> El sitio web de Medicina Total.</li>
          <li><strong>Usuario:</strong> Toda persona que navegue, se registre o acceda al contenido.</li>
          <li><strong>Curso:</strong> Material formativo ofrecido por Medicina Total.</li>
        </ul>
      </section>

      <section>
        <h2>3. Registro y cuenta</h2>
        <p>
          Para acceder al contenido es necesario registrarse con datos reales. Cada
          usuario es responsable de mantener la confidencialidad de su cuenta y contraseña.
        </p>
      </section>

      <section>
        <h2>4. Acceso y licencias de uso</h2>
        <p>
          El acceso a los cursos es personal, intransferible y no exclusivo. Está
          prohibido copiar, distribuir, grabar o revender el contenido sin autorización
          expresa de Medicina Total.
        </p>
      </section>

      <section>
        <h2>5. Política de reembolsos</h2>
        <p>
          Todos los accesos a los cursos son definitivos. Una vez otorgado el acceso al contenido,
          <strong> no se realizarán reembolsos bajo ninguna circunstancia</strong>, salvo errores administrativos
          atribuibles a Medicina Total. Antes de solicitar el acceso, asegurate de resolver todas tus dudas por
          nuestros canales de contacto.
        </p>
      </section>

      <section>
        <h2>6. Responsabilidades y exoneraciones</h2>
        <p>
          Los cursos son de carácter educativo y no sustituyen la consulta médica
          profesional. Medicina Total no se responsabiliza por el uso inadecuado
          del contenido ni por errores involuntarios en el material.
        </p>
      </section>

      <section>
        <h2>7. Modificaciones</h2>
        <p>
          Nos reservamos el derecho de modificar el contenido, los Términos y las condiciones
          de uso con previo aviso a través del sitio o por correo electrónico.
        </p>
      </section>

      <section>
        <h2>8. Terminación o suspensión</h2>
        <p>
          Podemos suspender cuentas por uso indebido, suplantación de identidad,
          intento de copia de contenido u otras actividades que infrinjan estos Términos.
        </p>
      </section>

      <section>
        <h2>9. Comunicaciones</h2>
        <p>
          Cualquier solicitud, duda o acuerdo (incluyendo condiciones de acceso) debe
          realizarse escribiendo a{" "}
          <a href="mailto:medicinatotal91@gmail.com">medicinatotal91@gmail.com</a> o por Instagram{" "}
          <a href="https://instagram.com/medicina_total1" target="_blank" rel="noopener noreferrer">
            @medicina_total1
          </a>.
        </p>
      </section>

      <section>
        <h2>10. Ley aplicable y jurisdicción</h2>
        <p>
          Estos Términos se rigen por las leyes de la República Argentina. Las partes se someten a la jurisdicción de los tribunales competentes del país.
        </p>
      </section>
    </div>
  );
}
